import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
    CircularProgress,

} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption";
import { BASE_URL } from "../../../../components/BaseUrl";
import { toast } from "react-hot-toast";
import CustomText, { textStyles } from "../../../../components/CustomText";
import CustomButton from "../../../../components/CustomButton";
import { useTranslation } from "react-i18next";


const EditExpenseModal = ({ open, onClose, expense }) => {
      const { t } = useTranslation();
    
  const [note, setNote] = useState("");
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
  const [loadingAction, setLoadingAction] = useState(null); // "approve" | "reject" | null

  if (!expense) return null;

  const handleAction = async (action) => {
        setLoadingAction(action); // start loader

    try {
      const url = `${BASE_URL}/company-admin/expenses/${expense.id}/${action}`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ decision_note: note }),
      });
      const result = await res.json();

      if (!result.error) {
        toast.success(result.message || `Expense ${action}d successfully`);
        onClose(true); // ✅ tell parent to refresh
      } else {
        toast.error(result.message || "Something went wrong");
      }
    } catch (err) {
      console.error(err);
      toast.error("API request failed");
    }
     finally {
      setLoadingAction(null); // stop loader
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose(false)} maxWidth="sm" fullWidth 
      PaperProps={{
    sx: {
      borderRadius: "12px", // ✅ rounded corners
    },
  }}>
      {/* Header with title + close icon */}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 600,
          fontSize: "18px",
        }}
      >
                 <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 20,
                      fontWeight: 600,
                      color: "#2C384C",
                    }}
                  >
{t("expenseModal.title")}        </CustomText>
        <IconButton onClick={() => onClose(false)}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mt: 0 }}>
          <label
            style={{
              fontSize: "16px",
              fontWeight: 500,
              color: "#333",
              marginBottom: "6px",
              display: "block",
            }}
          >
         {t("expenseModal.decisionNote")}
          </label>
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows={4}
            className='project_input'
            style={{
                width:"100%",
          height:"120px",
          paddingTop:"10px"
            }}
            placeholder={t("expenseModal.decisionNotePlaceholder")}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "flex-end", p: 2 }}>
      
          <Box sx={{ mt: 2, display: "flex",alignItems:"center" , flexWrap: "wrap", gap: 2 }}>
       
                      <Button
            onClick={() => handleAction("approve")}
           
            disabled={loadingAction === "approve"}
            sx={{ textTransform: "none", borderRadius: "5px", px: 3,
              py: 1,        fontFamily: 'Poppins, sans-serif',

              height: "42px",backgroundColor:"#006EC2",color:"white" }}
          >
            {loadingAction === "approve" && (
              <CircularProgress
                size={16}
                sx={{ color: "#fff", mr: 1 }}
              />
            )}
            {t("expenseModal.approve")}
          </Button>

          {/* Reject Button */}
          <Button
            onClick={() => handleAction("reject")}
            variant="outlined"
            disabled={loadingAction === "reject"}
            sx={{
              fontSize: 15,
              textTransform: "none",
              borderRadius: "5px",
              fontFamily: "Poppins, sans-serif",
              color: "#006EC2",
              border: "2px solid #006EC2",
              px: 3,
              py: 1,
              height: "42px",
            }}
          >
            {loadingAction === "reject" && (
              <CircularProgress
                size={16}
                sx={{ color: "#006EC2", mr: 1 }}
              />
            )}
            {t("expenseModal.reject")}
          </Button>
                  </Box>
      </DialogActions>
    </Dialog>
  );
};

export default EditExpenseModal;

